import styled from '@emotion/styled'

export const Cont = styled.div(()=>({
  display:'flex',
  flexDirection:'column',
  marginRight:15,
  flex:1,

  'span':{
    fontSize:'0.85rem',
    color:'#888888'
  },
  'div':{
    color:'#888888',
    border: '1px solid rgba(34,36,38,.15)',
    lineHeight: '1.21428571em',
    padding: '.67857143em 1em',
    borderRadius: '.28571429rem',
  }
}))
